module.exports = __webpack_public_path__ + "static/media/egg.999ae10d.png";